export default "__VITE_ASSET__c5d914fc__"